import * as tslib_1 from "tslib";
import * as React from 'react';
import { StyledIconBase } from '../../StyledIconBase';
export var Ruler = React.forwardRef(function (props, ref) {
    var attrs = {
        "fill": "currentColor",
    };
    return (React.createElement(StyledIconBase, tslib_1.__assign({ iconAttrs: attrs, iconVerticalAlign: "middle", iconViewBox: "0 0 24 24" }, props, { ref: ref }),
        React.createElement("path", { d: "M19.875 7H4.125C2.953 7 2 7.897 2 9v6c0 1.103.953 2 2.125 2h15.75C21.047 17 22 16.103 22 15V9c0-1.103-.953-2-2.125-2zm0 8H4.125c-.057 0-.096-.016-.113-.016-.007 0-.011.002-.012.008l-.012-5.946c.007-.01.052-.046.137-.046H7v3h2V9h2v4h2V9h2v3h2V9h2.875c.079.001.123.028.125.008l.012 5.946c-.007.01-.052.046-.137.046z", key: "k0" })));
});
Ruler.displayName = 'Ruler';
export var RulerDimensions = { height: 24, width: 24 };
